import { render } from "./WCMobileNavigation.vue?vue&type=template&id=2f5d6139&scoped=true"
import script from "./WCMobileNavigation.vue?vue&type=script&lang=js"
export * from "./WCMobileNavigation.vue?vue&type=script&lang=js"

import "./WCMobileNavigation.vue?vue&type=style&index=0&id=2f5d6139&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5d6139"]])

export default __exports__